export default __webpack_public_path__ + "static/media/norestforthedead.a989cbb4.png";